import PlacesAutocomplete, {
    geocodeByAddress,
    getLatLng,
    geocodeByPlaceId,
} from "react-places-autocomplete";
import Geocode from "react-geocode";
import { useEffect, useRef, useState } from "react";

import React from "react";
import { Button, MenuItem, TextField } from "@mui/material";
import { toast } from "react-toastify";

const GoogleMaps = ({ index, handleSetValues, handleSomeValues }) => {
    const [address, setAddress] = useState("");
    const [coordinates, setCoordinates] = useState();
    const [singleAdress, setSingleAddress] = useState();

    const handleSelect = async (value) => {
        const results = await geocodeByAddress(value);
        const latLng = await getLatLng(results[0]);
        console.log(value);
        setAddress(value);
        handleSomeValues(index, value, latLng.lat, latLng.lng);
        setCoordinates(latLng);
    };

    useEffect(() => {
        if (coordinates) {
            Geocode.setLocationType("ROOFTOP");
            Geocode.setApiKey("AIzaSyCrr_bBNHxQ0lZKadmJYpqS2vOebczD1m4");
            Geocode.fromLatLng(coordinates?.lat, coordinates?.lng).then(
                async (response) => {
                    const address = response.results[0].formatted_address;
                    // setFullAddress(address);
                    let street, city, state, country, postalCode, route;
                    for (
                        let i = 0;
                        i < response.results[0].address_components.length;
                        i++
                    ) {
                        for (
                            let j = 0;
                            j <
                            response.results[0].address_components[i].types
                                .length;
                            j++
                        ) {
                            // eslint-disable-next-line default-case
                            switch (
                                response.results[0].address_components[i].types[
                                    j
                                ]
                            ) {
                                case "street_number":
                                    street =
                                        response.results[0].address_components[
                                            i
                                        ].long_name;
                                    break;
                                case "locality":
                                    city =
                                        response.results[0].address_components[
                                            i
                                        ].long_name;
                                    break;
                                case "postal_code":
                                    postalCode =
                                        response.results[0].address_components[
                                            i
                                        ].long_name;
                                    break;
                                case "administrative_area_level_1":
                                    state =
                                        response.results[0].address_components[
                                            i
                                        ].short_name;
                                    break;
                                case "country":
                                    country =
                                        response.results[0].address_components[
                                            i
                                        ].long_name;
                                    break;

                                case "route":
                                    route =
                                        response.results[0].address_components[
                                            i
                                        ].long_name;
                                    break;
                            }
                        }
                    }
                    // Set the Normal states
                    handleSetValues(
                        index,
                        singleAdress,
                        address,
                        postalCode,
                        street,
                        country,
                        state,
                        route,
                        city,
                        coordinates
                    );
                },
                (error) => {
                    toast.success(error);
                }
            );
        }
    }, [coordinates, handleSetValues, singleAdress, address, index]);

    return (
        <PlacesAutocomplete
            value={address}
            onChange={setAddress}
            onSelect={handleSelect}
        >
            {({
                getInputProps,
                suggestions,
                getSuggestionItemProps,
                loading,
            }) => (
                <div>
                    <TextField
                        sx={{ mb: 3 }}
                        fullWidth
                        {...getInputProps({
                            placeholder: "Type Your address",
                        })}
                    ></TextField>

                    <div>
                        {loading ? <div>...loading</div> : null}
                        {suggestions.map((suggestion) => {
                            const style = {
                                backgroundColor: suggestion.active
                                    ? "#41b6e6["
                                    : "#fff",
                                textAlign: "center",
                                fontSize: "13px",
                            };
                            return (
                                <MenuItem
                                    style={{ border: "1px solid black" }}
                                    {...getSuggestionItemProps(suggestion, {
                                        style,
                                    })}
                                    key={Math.random()}
                                >
                                    {suggestion.description}
                                </MenuItem>
                            );
                        })}
                    </div>
                </div>
            )}
        </PlacesAutocomplete>
    );
};

export default GoogleMaps;
